<template>
    <CRow>
        <CCol col>
            <ejs-grid ref='grid' :dataSource="ccData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin="actionBegin" :actionComplete='actionComplete' :actionFailure="actionFailure" :filterSettings='filterOptions'>
                <e-columns>
                    <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                    <e-column field='firstName' headerText='First Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='lastName' headerText='Last Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='email' headerText='Email' textAlign='Right' :validationRules='emailRules' width=90></e-column>
                    <e-column field='position' headerText='Position' :validationRules="nameRules" width=120></e-column>
                    <e-column field='office' headerText='Office' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='officeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='offices' width=90></e-column>
                    <e-column field='officeName' headerText='Office Name' :visible='false' width=120></e-column>
                </e-columns>
            </ejs-grid>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';

    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let offices = SyncHelper.getDataManager('Utils/offices');

    let roleObj, roleElem, clientObj, clientElem;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                offices: offices,
                ccData: SyncHelper.getDataManager("ClientCoordinator"),
                officeParams: {
                    create: () => {
                        roleElem = document.createElement('input');
                        return roleElem;
                    },
                    read: () => {
                        return roleObj.value;
                    },
                    destroy: () => {
                        roleObj.destroy();
                    },
                    write: (args) => {
                        roleObj = new DropDownList({
                            dataSource: offices,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Office',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                        });
                        roleObj.appendTo(roleElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.ClientCoordinator.Update"],
                    allowAdding:store.state.permissions["Permissions.ClientCoordinator.Create"],
                    allowDeleting: store.state.permissions["Permissions.ClientCoordinator.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                emailRules: { email: true, required: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[6].visible = true; // add officename column
                    this.$refs.grid.getColumns()[5].visible = false; //remove office column
                }
                gridOptions.excelExport(args, "Client Coordinators.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.getColumns()[5].visible = true; 
                this.$refs.grid.getColumns()[6].visible = false; 
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            }

        },

        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
    .e-textbox[id$="email"] {
        text-align: Left !important;
    }
</style>
